import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_Sunmenu = _resolveComponent("Sunmenu")!
  const _component_a_menu = _resolveComponent("a-menu")!

  return (_openBlock(), _createBlock(_component_a_menu, {
    mode: _ctx.mode,
    theme: _ctx.theme,
    selectedKeys: _ctx.selectedKey,
    inlineIndent: 10,
    openKeys: _ctx.openKey,
    "onUpdate:openKeys": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.openKey) = $event)),
    openKeysModifiers: { sync: true },
    onSelect: _ctx.handleClick
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (!item.children)
            ? (_openBlock(), _createBlock(_component_a_menu_item, {
                key: item.key,
                title: item.title
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.title), 1)
                ]),
                _: 2
              }, 1032, ["title"]))
            : (_openBlock(), _createBlock(_component_Sunmenu, {
                data: item,
                key: item.key
              }, null, 8, ["data"]))
        ], 64))
      }), 256))
    ]),
    _: 1
  }, 8, ["mode", "theme", "selectedKeys", "openKeys", "onSelect"]))
}